export function metricPercent(value: number | null | undefined, signed = false): string {
  return value == null || !Number.isFinite(value) ? '—' : `${signed && value > 0 ? '+' : ''}${value}%`;
}

export function riskLabel(value: string): string {
  return ({ conservative: '稳健', moderate: '均衡', aggressive: '激进', standard: '标准', strict: '严格', account_policy: '按账户策略风控' } as Record<string, string>)[value] || '风险说明暂不可用';
}
